import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { RestapiService } from '../restapi.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-admin-qrview',
  templateUrl: './admin-qrview.component.html',
  styleUrls: ['./admin-qrview.component.css']
})
export class AdminQrviewComponent implements OnInit {
	respRes: any;
	fileName="";
	fileData: any;
	safeHtml: SafeHtml;
	downLoadPath=this._rest.FILE_PATH;
	showDownload=false;
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  	this.showDownload=false;
  	this.route.params.forEach((params: Params) => {
		var saveData	=	{
			"companyId":localStorage.getItem('companyId'),
			"userId":localStorage.getItem('userId'),
			"requestId":params['id']
		};
		this._rest.getAdminCustomReport(saveData).subscribe((res) => {
			this.respRes	=	res;
			//console.log(this.respRes);
			if(this.respRes.error==0){
				//alert("ok");
				this.fileName= this.respRes.resp.fileName;
				this.fileData= JSON.parse(this.respRes.resp.fileData);
				var iiHtml ="";
				for(var i=0;i<this.fileData.length;i++){
					iiHtml +="<tr>";
					for(var j=0;j<this.fileData[i].length;j++){
						iiHtml += "<td>"+this.fileData[i][j]+"</td>";
					}
					iiHtml +="</tr>";
				}
				this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(iiHtml);
				console.log(this.fileData);
				this.showDownload=true;
			} else {
				alert(this.respRes.errorMessage);
				this.router.navigate(['/admin/queryreport']);
			}
		});
    });
  }
  backfile(){
  	this.router.navigate(['/admin/queryreport']);
  }

}

